import React, { Component, Fragment } from 'react';
import { addField } from 'ra-core';
import Map from './map';
import { getMarkers, getPosition, getMidPoint } from './utils';
import * as Constants from '../constants'
import CircularProgress from '@material-ui/core/CircularProgress';

export default class GMapForOverlay extends Component {
    constructor(props) {
        super(props);
        const { defaultZoom, defaultCenter } = this.props;
        this._mapRef = React.createRef();

        const ne = props.formData.coordinate ? props.formData.coordinate.north_east : props.formData.north_east;
        const sw = props.formData.coordinate ? props.formData.coordinate.south_west : props.formData.south_west;

        if(ne && sw){
            this.updateCoordinateBaseOnBounds(parseFloat(ne.lat),parseFloat(ne.lng),parseFloat(sw.lat),parseFloat(sw.lng));
        }

        this.state = {
            center: defaultCenter || ne && sw && ne.lat && ne.lng && sw.lat && sw.lng ? getMidPoint(parseFloat(ne.lat), parseFloat(ne.lng), parseFloat(sw.lat), parseFloat(sw.lng)) : { lat: 31.880012, lng: 35.01361 },
            zoom: defaultZoom || 15,
            image: props.formData.image && props.formData.image.src ? props.formData.image.src : props.formData.image_url ? props.formData.image_url : "",
            bounds: ne && sw && ne.lat && ne.lng && sw.lat && sw.lng ? [[parseFloat(ne.lat), parseFloat(ne.lng)], [parseFloat(sw.lat), parseFloat(sw.lng)]] : [],
            isImageLoaded: props.formData.image_url ? true : false,
        };

        if(props.formData.image_url){
            const img = new Image();
            img.src = props.formData.image_url;
            img.onload = () => {
                this.setState({ isImageLoaded: true });
            }
        }
        this.oldImgSrc = props.formData.image_url;
    }

    componentDidMount() {
    }

     componentDidUpdate(prevProps) {
        let isLoadImage = false;
        const coordinate = this.props.formData.coordinate ? this.props.formData.coordinate : this.props.formData.north_east ? this.props.formData: null;
        const oldCoordinate = prevProps.formData.coordinate ? prevProps.formData.coordinate : prevProps.formData.north_east ? prevProps.formData: null;
        if (coordinate && oldCoordinate) {
            if (coordinate.north_east.lat !== oldCoordinate.north_east.lat || coordinate.north_east.lng !== oldCoordinate.north_east.lng ||
                coordinate.south_west.lat !== oldCoordinate.south_west.lat || coordinate.south_west.lng !== oldCoordinate.south_west.lng) {
                this.loadImage([[coordinate.north_east.lat, coordinate.north_east.lng],
                [coordinate.south_west.lat, coordinate.south_west.lng]]);
                this.updateCoordinateBaseOnBounds(parseFloat(coordinate.north_east.lat), parseFloat(coordinate.north_east.lng),
                    parseFloat(coordinate.south_west.lat), parseFloat(coordinate.south_west.lng));
                isLoadImage = true;
            }
            else {
                if (coordinate.north_west.lat !== oldCoordinate.north_west.lat || coordinate.north_west.lng !== oldCoordinate.north_west.lng) {
                    this.loadImage([[coordinate.north_west.lat, coordinate.north_east.lng],
                    [coordinate.south_west.lat, coordinate.north_west.lng]]);
                    this.updateCoordinateBaseOnBounds(parseFloat(coordinate.north_west.lat), parseFloat(coordinate.north_east.lng),
                        parseFloat(coordinate.south_west.lat), parseFloat(coordinate.north_west.lng));
                        isLoadImage = true;
                    }
                else {
                    if (coordinate.south_east.lat !== oldCoordinate.south_east.lat || coordinate.south_east.lng !== oldCoordinate.south_east.lng) {
                        this.loadImage([[coordinate.north_east.lat, coordinate.south_east.lng],
                        [coordinate.south_east.lat, coordinate.south_west.lng]]);
                        this.updateCoordinateBaseOnBounds(parseFloat(coordinate.north_east.lat), parseFloat(coordinate.south_east.lng),
                            parseFloat(coordinate.south_east.lat), parseFloat(coordinate.south_west.lng));
                            isLoadImage = true;
                        }
                }
            }
        }
        if(!isLoadImage && this.props.formData.image && this.oldImgSrc != this.props.formData.image.src && coordinate){
            this.loadImage([[coordinate.north_east.lat, coordinate.north_east.lng],
                [coordinate.south_west.lat, coordinate.south_west.lng]]);
        }
    }

    loadImage = (bounds) => {
        const { formData } = this.props;
        if (formData.image) {
            const imgUrl = formData.image.src ? formData.image.src : formData.image
            const img = new Image();
            img.src = imgUrl;
            this.setState({
                image: imgUrl,
                bounds: bounds
            })
            img.onload = () => {
                this.setState({ isImageLoaded: true });
            }
            this.oldImgSrc = formData.image.src;
        }
    }

    updateCoordinatesInputs = () => {
        if (!this.state.isImageLoaded) {
            let bound = this._mapRef.getBounds();
            if (!bound) return;
            let ne = bound.getNorthEast();
            let sw = bound.getSouthWest();

            this.updateCoordinateBaseOnBounds(parseFloat(ne.lat()), parseFloat(ne.lng()), parseFloat(sw.lat()), parseFloat(sw.lng()));

            if (this.props.formData.image && !this.props.formData.image_url && !this.state.isImageLoaded) {
                this.loadImage([[ne.lat(), ne.lng()], [sw.lat(), sw.lng()]]);
            }
        }
    }

    updateCoordinateBaseOnBounds = (neLat, neLng, swLat, swLng) => {
        let boundJson = {
            north_east: { lat: parseFloat(neLat.toFixed(6)), lng: parseFloat(neLng.toFixed(6)) }, south_west: { lat: parseFloat(swLat.toFixed(6)), lng: parseFloat(swLng.toFixed(6)) },
            north_west: { lat: parseFloat(neLat.toFixed(6)), lng: parseFloat(swLng.toFixed(6)) }, south_east: { lat: parseFloat(swLat.toFixed(6)), lng: parseFloat(neLng.toFixed(6)) }
        };

        this.props.input.onChange(boundJson);
    };

    getMarkers = () => {
        const { formData } = this.props;
        if (formData.image && this.state.isImageLoaded) {
            const coordinate = formData.coordinate ? formData.coordinate : formData;
            return [{ lat: coordinate.north_east.lat, lng: coordinate.north_east.lng },
            { lat: coordinate.north_west.lat, lng: coordinate.north_west.lng },
            { lat: coordinate.south_east.lat, lng: coordinate.south_east.lng },
            { lat: coordinate.south_west.lat, lng: coordinate.south_west.lng }]
        }
    };

    markerMoved = (order) => {
        const coordinate = this.props.formData.coordinate ? this.props.formData.coordinate : this.props.formData;
        const newMarkerPosition = this._mapRef.getMrkPosition(order);

        let imageBounds = [];

        switch (order) {
            case 0:
                imageBounds = [[newMarkerPosition.lat(), newMarkerPosition.lng()],
                [coordinate.south_west.lat, coordinate.south_west.lng]];
                break;
            case 1:
                imageBounds = [[newMarkerPosition.lat(), coordinate.north_east.lng],
                [coordinate.south_west.lat, newMarkerPosition.lng()]];
                break;
            case 2:
                imageBounds = [[coordinate.north_east.lat, newMarkerPosition.lng()],
                [newMarkerPosition.lat(), coordinate.south_west.lng]];
                break;
            default:
                imageBounds = [[coordinate.north_east.lat, coordinate.north_east.lng],
                [newMarkerPosition.lat(), newMarkerPosition.lng()]];
        }

        this.updateCoordinateBaseOnBounds(parseFloat(imageBounds[0][0]), parseFloat(imageBounds[0][1]), parseFloat(imageBounds[1][0]), parseFloat(imageBounds[1][1]));

        this.setState({
            bounds: imageBounds
        });
    };

    groundOverlayDragged = async(newBounds) =>{
        const ne = newBounds[0];
        let sw = newBounds[1];

        this.updateCoordinateBaseOnBounds(parseFloat(ne.lat()), parseFloat(ne.lng()), parseFloat(sw.lat()), parseFloat(sw.lng()));

            this.setState({
                bounds:[[ne.lat(), ne.lng()], [sw.lat(), sw.lng()]]
            });
        
    };

    render() {
        const {
            input,
            multipleMarkers,
        } = this.props;
        const childrenProps = {
            markers: this.getMarkers(),
            groundOverlayOpacity: this.props.formData.opacity,
            loadingElement: <div style={{ height: '100%' }} />,
            containerElement: <div style={{ height: '700px', minWidth: '200px' }} />,
            googleMapURL: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCTF0Xc4Q_2Kt85EVdtE_1dsJ3vTCanjUs&v=3.exp&libraries=geometry,drawing,places`,

        };

        const { center, zoom, image, bounds, isImageLoaded } = this.state;
        console.log(isImageLoaded);
        return (
            <Fragment>
                <div style={{ position: 'relative' }}>
                    <Map
                        ref={ref => this._mapRef = ref}
                        mapElement={<div style={{ height: '100%' }} />}
                        center={center}
                        image={image}
                        bounds={bounds}
                        defaultZoom={zoom}
                        onMapClick={e => { }}
                        onMarkerClick={e => { }}
                        draggableMarkers
                        onMarkerPositionChanged={this.markerMoved}
                        onBoundsChanged={this.updateCoordinatesInputs}
                        draggableGroundOverlay
                        onGroundOverlayDragged={this.groundOverlayDragged}
                        {...childrenProps}
                    />
                </div>
            </Fragment>
        );
    }
}

export const GMapForOverlayInput = addField(GMapForOverlay);
export const GMapForOverlayField = ({ record, source, ...props }) => (
    <GMapForOverlay
        {...props}
        justShow
        input={{ value: record[source] }}
        searchable={false}
    />
);